import { ApiService } from '../_services/ApiService';

export interface IUsersInfo {
    user_id: number;
    joined_at: string;
}

export interface IFamilyFromServer {
    name: string;
    id: number;
    created_at: string;
    user_id: number;
    collections_info?: Array<any>;
    users_info?: Array<IUsersInfo>;
}

export class UserFamilyService extends ApiService {
    protected basePath = 'family';
    protected subPaths = {
        getByID: (id: number) => `${id}`,
        getCollectionByFamilyID: (id: number) => `${id}/collections`,
        getUserByFamilyID: (id: number) => `${id}/users`,
        inviteUserToFamily: (id: number) => `${id}/invite`,
        pendingMembersForFamily: (id: number) => `${id}/pendingInvites`
    };

    public getAllFamilies(): Promise<Array<IFamilyFromServer>> {
        return this.getRequest();
    }

    public getFamilyByID(id: number): Promise<IFamilyFromServer> {
        return this.getSubPath(this.subPaths.getByID(id)).then(([response]) => {
            return response;
        });
    }

    public inviteUserToFamily(familyID: number, email: string, first_name: string): Promise<void> {
        return this.postSubPath(this.subPaths.inviteUserToFamily(familyID), { email, first_name });
    }

    public createFamily(name: string): Promise<IFamilyFromServer> {
        return this.postRequest({ name, members: [] });
    }

    public renameFamily(id: number, name: string): Promise<void> {
        return this.putSubPath(this.subPaths.getByID(id), { name });
    }

    public shareCollectionToFamily(familyID: number, collectionID: number): Promise<void> {
        return this.postSubPath(this.subPaths.getCollectionByFamilyID(familyID), { collection_id: collectionID });
    }

    public removeUserFromFamily(familyID: number, userID: number): Promise<void> {
        return this.deleteSubPath(this.subPaths.getUserByFamilyID(familyID), { target_user_id: userID });
    }

    public getUsersInFamily(familyID: number): Promise<Array<IUsersInfo>> {
        return this.getSubPath(this.subPaths.getUserByFamilyID(familyID));
    }

    public getPendingMembersForFamily(familyID: number): Promise<Array<{ email: string }>> {
        return this.getSubPath(this.subPaths.pendingMembersForFamily(familyID));
    }
}



// WEBPACK FOOTER //
// ./src/Services/UserFamilyService.tsx